// import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import App from "./containers/app/App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./config/api.config";
import Aos from "aos";

const root = ReactDOM.createRoot(document.getElementById("root"));

Aos.init();

function MainApp() {
  useEffect(() => {
    
    if (navigator.storage && navigator.storage.persist) {
      navigator.storage.persist().then((granted) => {
        console.log(
          granted
            ? "✅ Storage dilindungi dari auto-clear Chrome"
            : "⚠ Storage masih bisa dihapus oleh sistem jika idle"
        );
      });
    }

    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("/service-worker.js")
        .then((registration) => {
          console.log(
            "Service Worker registered with scope:",
            registration.scope
          );
        })
        .catch((error) => {
          console.error("Service Worker registration failed:", error);
        });
    }

  }, []);

  return <App />;
}

root.render(
  <Router>
    <MsalProvider instance={msalInstance}>
      <MainApp />
    </MsalProvider>
  </Router>
);

reportWebVitals();
